var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1VideoMonitoring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 65.25V71H37v-5.75A6.37 6.37 0 0143.48 59h22A6.39 6.39 0 0172 65.25zM49.13 52.78a6.75 6.75 0 101.07-9.48 6.73 6.73 0 00-1.07 9.48zm-9.21-15.46L35 34l-4 1.49-5-3.65V43H6v-4h16V28.92L5.92 17.06 18.08 3.15l32.66 25-6.37 2.35 4.5 3.39-8.95 3.43zm2.46-10.53L18.44 8.48 11.6 16.3l19.79 14.6 10.99-4.11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Video_Monitoring.4a41b7aa.svg";
export { SvgG1VideoMonitoring as ReactComponent };